<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-building fa-fw"
                            :edicao="!$store.state.user.id_unidade_operacao"
                            type="select"
                            placeholder="Todas"
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtro.id_unidade_operacao">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Todas as Contas..."
                            icon="fas fa-money-check-alt"
                            type="select"
                            optionsMode="aql"
                            service="contas.index"
                            optionsName="contas.index.vales"
                            optionsData="id_conta"
                            optionsDisplay="search"
                            :optionsParm="{ ativas: true, classificacao: true, vale: true }"
                            v-model="filtro.id_conta" />
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa fa-filter fa-fw"
                            type="select"
                            placeholder="Todos"
                            :optionsList="[
                                { id: 'A', search: 'Abertos' },
                                { id: 'E', search: 'Encerrados' }
                            ]"
                            optionsData="id"
                            v-model="filtro.situacao">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-10">
                        <az-input
                            icon="fas fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <span class="input-group-text" v-if="lista.length" title="Quantidade">{{ lista.length }}</span>
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" title="Incluir novo vale." @click="incluir()">
                                        <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <print-export printid="impressao" />
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados && dados.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state icon="fa-solid fa-sack-dollar" v-if="!lista.length" :loading="true" :msg="dados === null ? 'Buscar Vales' : 'Nenhum Vale Identificado.'" />

        <template v-else>

            <div class="card mb-2 dashcard" v-for="(vale, isx) in lista" :key="isx">
                <div class="card-body py-2 px-3">
                    <div class="row">
                        <div class="col col-12 col-md-2 d-flex flex-column justify-content-center">
                            <div>
                                <a href="#" @click.prevent="editar(vale)" class="card-link">
                                    #{{ vale.id_vale }}
                                </a>
                                <span class="badge badge-light ml-2" v-if="vale.unidade_operacao">{{ vale.unidade_operacao.st_sigla }}</span>
                            </div>
                            <div>{{ $util.getFormatDate(vale.created_at) }}</div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div v-if="vale.conta_origem">
                                <i class="fa-solid fa-right-from-bracket fa-fw mr-2"></i>
                                {{ vale.conta_origem.st_conta }}
                            </div>
                            <div v-if="vale.conta_vale">
                                <i class="fa-solid fa-right-to-bracket fa-fw mr-2"></i>
                                {{ vale.conta_vale.st_conta }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div>{{ vale.st_nome }}</div>
                            <div>
                                {{ $util.formatMoeda(vale.dc_valor) }}
                                <span class="ml-1" v-if="vale.lancamentos && vale.lancamentos.length != 1">
                                    / {{ $util.formatMoeda(vale.saldo) }}
                                </span>
                                <span class="badge badge-secondary ml-2" v-if="vale.lancamentos">
                                    {{ vale.lancamentos.length }}
                                </span>
                            </div>
                        </div>
                        <div class="col col-12 col-md-2 text-right">
                            <template v-if="!vale.fl_concluido">
                                <a href="#" @click.prevent="lancar(vale)" class="btn btn-sm btn-outline-primary mr-3">
                                    <i class="fa-solid fa-plus"></i>
                                    Lançamento
                                </a>
                                <span class="h5 mb-0">
                                    <i class="fa-solid fa-door-open"></i>
                                </span>
                            </template>
                            <span class="h5 mb-0" v-else>
                                <i class="fa-solid fa-door-closed"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <br><br><br><br><br>

        </template>

        <edicao-lancamento ref="lancamento" @refresh="load()" />

        <!-- Modal Lançamento de Vale -->
        <div class="modal fade" id="edicaoValeModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ edicao.id_vale ? '' : 'Novo' }}
                            Vale
                            <span class="ml-2" v-if="edicao.id_vale">
                                #{{ edicao.id_vale }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Unidade"
                                    :edicao="!$store.state.user.id_unidade_operacao"
                                    type="select"
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="edicao.id_unidade_operacao">
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row" v-if="edicao.id_unidade_operacao">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Conta Caixa"
                                    placeholder="Selecione a conta de origem..."
                                    type="select"
                                    optionsMode="aql"
                                    service="contas.index"
                                    :optionsName="'contas.index.caixa.' + edicao.id_unidade_operacao"
                                    optionsData="id_conta"
                                    optionsDisplay="search"
                                    :optionsParm="{ ativas: true, tipo: 'X', id_unidade_operacao: edicao.id_unidade_operacao }"
                                    v-model="edicao.id_conta_origem" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Conta Vale"
                                    placeholder="Selecione a conta vale..."
                                    type="select"
                                    optionsMode="aql"
                                    service="contas.index"
                                    :optionsName="'contas.index.vale.' + edicao.id_unidade_operacao"
                                    optionsData="id_conta"
                                    optionsDisplay="search"
                                    :optionsParm="{ ativas: true, tipo: 'V', id_unidade_operacao: edicao.id_unidade_operacao }"
                                    v-model="edicao.id_conta_vale" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Responsável"
                                    required
                                    :validate="validate"
                                    v-model="edicao.st_nome" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Valor"
                                    type="money"
                                    required
                                    :validate="validate"
                                    v-model="edicao.dc_valor" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Observações"
                                    type="textarea"
                                    v-model="edicao.st_observacoes" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Fechamento Vale -->
        <div class="modal fade" id="fecharValeModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="edicao_final">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Vale
                            <span class="badge badge-secondary">#{{ edicao_final.id_vale }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" id="impressao-vale">
                        <cabecalho-generico titulo="Vale">
                            <div>
                                Número: #{{ edicao_final.id_vale }}
                            </div>
                        </cabecalho-generico>

                        <div class="d-flex justify-content-between">
                            <div>
                                <div v-if="edicao_final.unidade_operacao">
                                    <i class="fa-solid fa-building fa-fw mr-2"></i>
                                    {{ edicao_final.unidade_operacao.st_nome }}
                                </div>
                                <div v-if="edicao_final.conta_origem">
                                    <i class="fa-solid fa-right-from-bracket fa-fw mr-2"></i>
                                    {{ edicao_final.conta_origem.st_conta }}
                                </div>
                                <div v-if="edicao_final.conta_vale">
                                    <i class="fa-solid fa-right-to-bracket fa-fw mr-2"></i>
                                    {{ edicao_final.conta_vale.st_conta }}
                                </div>
                                <div>
                                    <i class="fa-solid fa-user fa-fw mr-2"></i>
                                    {{ edicao_final.st_nome }}
                                </div>
                                <div>
                                    <i class="fa-regular fa-calendar-plus fa-fw mr-2"></i>
                                    {{ $util.getFormatDate(edicao_final.created_at) }}
                                </div>
                                <div>
                                    <i class="fa-solid fa-brazilian-real-sign fa-fw mr-2"></i>
                                    {{ $util.formatMoeda(edicao_final.dc_valor) }}
                                </div>
                            </div>
                            <div class="h3 text-right">
                                Saldo: {{ $util.formatMoeda(edicao_final.saldo) }}
                                <div class="mt-3 d-print-none" v-if="!edicao_final.fl_concluido">
                                    <button type="button" class="btn btn-outline-danger" @click="encerrar_vale()">
                                        Encerrar Vale
                                    </button>
                                </div>
                            </div>
                        </div>
                        <template v-if="edicao_final.st_observacoes">
                            <hr>
                            <div style="white-space: pre-wrap;">{{ edicao_final.st_observacoes }}</div>
                        </template>

                        <table class="table table-sm table-houver mt-3">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Data</th>
                                    <th>Descrição</th>
                                    <th class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(lanc, ilx) in edicao_final.lancamentos" :key="ilx">
                                    <td>#{{ lanc.id_lancamento }}
                                        <a href="#" @click.prevent="abrir_anexar_arquivo(lanc)" class="ml-2 card-link d-print-none">
                                            <i class="fa fa-plus" aria-hidden="true" v-if="!lanc.arquivos.length"></i>
                                            <div class="spinner-border spinner-border-sm" role="status" v-else-if="lanc.carregando">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <i class="fa fa-paperclip" aria-hidden="true" v-else></i>
                                        </a>
                                    </td>
                                    <td>{{ $util.getFormatDate(lanc.dt_emissao) }}</td>
                                    <td>{{ lanc.st_descricao }}</td>
                                    <td class="text-right">
                                        <span class="badge badge-danger" v-if="lanc.ch_estado == 'C'">Cancelado</span>
                                        <span v-if="lanc.baixa">{{ $util.formatMoeda(lanc.baixa.valor_liquido) }}</span>
                                        <i class="fa-solid fa-circle-plus text-success fa-fw ml-3" v-if="lanc.ch_tipo_lancamento == 'T' && lanc.id_conta_destino == edicao_final.id_conta_vale"></i>
                                        <i class="fa-solid fa-circle-minus text-danger fa-fw ml-3" v-else-if="lanc.ch_tipo_lancamento != 'C'"></i>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="3">Saldo</th>
                                    <th class="text-right">
                                        <span>{{ $util.formatMoeda(edicao_final.saldo) }}</span>
                                        <i class="fa-solid fa-circle text-primary fa-fw ml-3"></i>
                                    </th>
                                </tr>
                            </tfoot>
                        </table>

                        <pre v-if="false">{{ edicao_final }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" @click="imprimir('impressao-vale')">
                            <i class="fa fa-print" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <pre v-if="false">{{ dados }}</pre>

        <template v-if="acao_anexar && item">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="item.arquivos"
                :parms="{ model_type: 'lancamento', model_id: item.id_lancamento }" />
        </template>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
// import LancamentosModal from './LancamentosModal.vue';
import PrintExport from '../../shared/PrintExport.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import EdicaoLancamento from './EdicaoLancamento.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';

export default {
    data() {
        return { 
            filtro: { 
                periodo: 'm', 
                id_unidade_operacao: this.$store.state.user.id_unidade_operacao, 
                search: "", 
                st_tipo: "", 
                tipo_saldo:  "F", 
                tipo_quebra: "G", 
                id_conta: "", 
                situacao: "A", 
            }, 
            dados: null, 
            edicao: null, 
            edicao_final: null, 
            validate: false, 
            acao_anexar: false, 
            item: null, 
        }
    },

    components: { 
        AzInput,
        AzPeriodo, 
        AzEmptyState,
        PrintExport, 
        AzSubmit, 
        EdicaoLancamento, 
        // LancamentosModal, 
        CabecalhoGenerico, 
        AzFileUpload, 
    }, 

    computed: { 
        lista() { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.filtro.search);

            return this.dados.filter(item => !this.filtro.search || reg.test(JSON.stringify(item)));
        },

        lista_agrupada: function () { 
            return _.groupBy(this.lista, item => { 
                switch (this.filtro.tipo_quebra) {
                    case 'G': return '-';
                    case 'U': return item.unidade_operacao.search;
                    case 'T': return item.tipo;
                    default: return '-';
                }
            });
        },

        classes() { 
            return _.orderBy(
                    _.uniq(
                    this.dados.contas.flatMap(item => item.js_classes ? item.js_classes : [])
                ),
                item => item.toUpperCase()
            );
        },

        tem_cheque_especial() { 
            return this.lista.find(item => item.dc_cheque_especial > 0) ? true : false;
        }
    }, 

    methods: { 
        abrir_anexar_arquivo(item) { 
            this.item = item;

            if ( this.item.arquivos && this.item.arquivos.length && !this.item.arquivos.find(arq => arq.arquivo) ) { 
                this.item.carregando = true; 

                this.carregar_arquivos(true);

            } else { 

                this.acao_anexar = true;

                this.$nextTick(() => { 
                    this.$refs.upload.abrir();
                });
                
            }

        },

        carregar_arquivos (abrir = false) { 

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'financeiro',
                func: 'show',
                parms: { 
                id: this.item.id_lancamento,
                },
            })
            .then(res => { 
                this.item.arquivos = res.arquivos;
                this.acao_anexar = true;

                if ( abrir ) { 
                this.$nextTick(() => { 
                    this.$refs.upload.abrir();
                });
                }
            })
            .finally(() => { 
                this.item.carregando = false; 
                this.$store.commit('loading', false);
            });

        },

        imprimir(printid) { 
            this.$nextTick(() => { 
                this.$htmlToPaper(printid, null, () => {
                    console.log("Printing");
                });
            });
        },

        encerrar_vale () { 
            if ( Math.round(this.edicao_final.saldo * 100) > 0 ) { 
                if ( !confirm('Confirma encerrar o vale e retornar o saldo para o caixa?') ) { 
                    return;
                }
            } else { 
                if ( !confirm('Confirma encerrar o vale?') ) { 
                    return;
                }
            }

            let vale = _.cloneDeep(this.edicao_final);

            vale.fl_concluido = true;

            this.$util.atualizar(this, { 
                service: 'vales',
                func: 'store',
                dados: vale,
                modal: 'fecharValeModal',
                reload: true,
            });
        },

        lancar (vale) { 
            this.$refs.lancamento.incluir(
                true, 
                vale.id_conta_vale, 
                { 
                    id_vale: vale.id_vale,
                    id_unidade_operacao: vale.id_unidade_operacao,
                }
            );
        },

        editar (vale) { 
            this.validate = false;
            this.edicao_final = null;

            this.$nextTick(() => { 
                this.edicao_final = _.cloneDeep(vale);
                $('#fecharValeModal').modal('show');
            });
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'vales',
                func: 'store',
                dados: this.edicao, 
                modal: 'edicaoValeModal',
                reload: true, 
            });
        },

        incluir () { 
            this.validate = false; 
            this.edicao = null;

            this.$nextTick(() => { 

                this.edicao = { 
                    id_vale: null, 
                    id_unidade_operacao: "", 
                    id_conta_origem: "",
                    id_conta_vale: "",
                    st_nome: "", 
                    dc_valor: 0, 
                    st_observacoes: ""
                };

                $('#edicaoValeModal').modal('show');

            });
        },

        filtrar (texto) { 
            if ( this.filtro.search == '"' + texto + '"' ) { 
                this.filtro.search = "";
            } else { 
                this.filtro.search = '"' + texto + '"';
            }
        },

        total: function (campo, lista = null) { 
            if ( !lista ) { 
                lista = this.lista;
            }

            return lista.reduce((a, b) => a + parseFloat(_.get(b, campo)), 0);
        },

        load() { 
            this.$util.load(this, { 
                service: 'vales',
                func: 'index', 
                parms: { 
                    ...this.filtro, 
                    lista: true, 
                },
                loadTo: res => { 
                    this.dados = res; 
                },
            });
        },

        abrir_lancamentos (conta) { 
            let parms = { 
                filtros: { 
                    ...this.filtro, 
                    id_conta: conta.id_conta, 
                    // natureza: natureza, 
                }, 
                origem: 'B', 
            };

            this.$refs.lancs.abrir(parms);
        }, 
    },

    beforeMount() { 
        this.filtro.id_unidade_operacao = this.$store.state.user.id_unidade_operacao
            ? this.$store.state.user.id_unidade_operacao
            : this.$util.getCookie('id_unidade_operacao');
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Financeiro", path: "/financeiro/visao" },
            { name: "Vales", path: "/financeiro/vales" }
        ]);
        
        this.load();
    }
}
</script>
